<template>
 <b-course-search
   :list="list"
   :search="search"
   :show-page-title="showPageTitle"
   :always-show-result-section="alwaysShowResultSection"
   :query-definition="queryDefinition"
   :pre-loaded-search-result="searchResult"
   @update-search-result="updateSearchResult"
 />
</template>

<script>

import {mapGetters, mapMutations} from "vuex";

export default {
  name: "Home",
  data() {
    return {
      search: window.bomconfig.searchComponent,
      list: window.bomconfig.resultComponent,
      showPageTitle: window.bomconfig.showPageTitle ?? true,
      alwaysShowResultSection: window.bomconfig.alwaysShowResultSection ?? true,
      queryDefinition: window.bomconfig.queryDefinition ?? {
        search: undefined,
        tags: {
          tag1: undefined,
          tag2: undefined,
          tag3: undefined,
        },
      },
    };
  },
  computed: {
    ...mapGetters("searchResult", {
      searchResult: "getSearchResult",
    }),
  },
  methods: {
    ...mapMutations("searchResult", {
      setSearchResult: "setSearchResult",
    }),
    updateSearchResult(searchResult) {
      this.setSearchResult(searchResult);
    },
  },
};
</script>

<style scoped>

</style>
